import { useState } from "react";
import { DSPDisplayModeContext } from "@x1-contexts/DSPDisplayModeContext";
import { X1DarkModeContext } from "@x1-contexts/X1DarkModeContext";
import { UseSystemPrefersDarkMode } from "@x1-hooks/useSystemPrefersDarkMode";
import { UseX1SetDarkModeMetaContent } from "@x1-hooks/useX1SetDarkModeMetaContent";

const isDarkModeEnabledGlobally = false;

function makeX1DarkModeStateProvider(props) {
  const { getDarkModeSetting, saveDarkModeSetting } = props;

  function DarkMode({ children }) {
    let prefersDarkMode =
      UseSystemPrefersDarkMode.useSystemPrefersDarkMode(getDarkModeSetting);

    const [darkModeSetting, setDarkModeSetting] = useState(getDarkModeSetting);

    const isDarkModeEnabled =
      darkModeSetting === "ENABLED" ||
      (darkModeSetting === "USE_SYSTEM" && prefersDarkMode);

    UseX1SetDarkModeMetaContent.useX1SetDarkModeMetaContent(isDarkModeEnabled);

    const themeDisplayMode = isDarkModeEnabledGlobally
      ? "dark"
      : darkModeSetting === "USE_SYSTEM"
        ? "auto"
        : darkModeSetting === "ENABLED"
          ? "dark"
          : "light";

    const updateDarkModeSetting = (newSetting) => {
      localStorage.setItem("isDarkMode", newSetting);
      setDarkModeSetting(newSetting);
      saveDarkModeSetting(newSetting, {
        onRevert: setDarkModeSetting,
      });
    };

    const toggleDarkMode = () => {
      updateDarkModeSetting(isDarkModeEnabled ? "DISABLED" : "ENABLED");
    };

    const contextValue = {
      onDarkModeToggle: toggleDarkMode,
      setDarkModeSetting: updateDarkModeSetting,
    };

    return (
      <X1DarkModeContext.Provider value={contextValue}>
        <DSPDisplayModeContext.Provider value={themeDisplayMode}>
          {children}
        </DSPDisplayModeContext.Provider>
      </X1DarkModeContext.Provider>
    );
  }

  return DarkMode;
}

export default makeX1DarkModeStateProvider;
